
    <div>
      <p ls-heading4 class="cr-text--content">{{ title }}</p>
      <ng-content></ng-content>
    </div>
  